import React, { useEffect, useState } from 'react';
import {
  Row, Col, size, breakpoints,
} from '@argo/principles';
import { kbbBaseUrl, atcBaseUrl } from '../../constants/config';
import { sendClick } from 'reaxl-analytics';
import { ImageLabel } from '@argo/base-patterns';
import styled from '@emotion/styled';
import { Heading } from '@argo/ui-elements';

const StyledDiv = styled.div`
  @media (max-width: ${breakpoints.lg}px) {
    padding: ${size.xl}px 0px;
  }
`;

const StyledImageLabel = styled(ImageLabel)`
  // CLS Fix: Use :nth-of-type instead of :nth-child for SSR consistency
  // Prevents minor layout shifts from server/client DOM mismatches
  > div:nth-of-type(2) > div {
    font-weight: 800;
  }

  background-color: transparent;
`;

const StyledCol = styled(Col)`
  text-align: center;
  @media (max-width: ${breakpoints.md}px) {
    padding-left: 0px;
  }

  @media (max-width: ${breakpoints.sm}px) {
    .odd {
      padding-right: ${size.sm}px;
    }
  }
`;

const StyledHeading = styled(Heading)`
  font-size: 36px;
  font-style: normal;
  font-weight: 800;
  line-height: ${size.xl}px;
  margin: 0;
  margin-bottom: ${size.md}px;

  @media (max-width: ${breakpoints.lg}px) {
    margin: 12px ${size.sm}px;
  }
`;

interface Vehicle {
  type: string;
  href: string;
  imageUrl: string;
  taggingLabel: string;
  shortHand: string;
  id: string;
}

const generateVehicleObjects = () => {
  const vehicleTypes = ['Sedan', 'Truck', 'SUV/Crossover', 'Coupe', 'Hatchback', 'Van/Minivan', 'Convertible', 'Wagon'];
  const vehicleObjects: Vehicle[] = [];
  for (const vehicleType of vehicleTypes) {
    const lowerCaseVehicleType = vehicleType.toLowerCase();
    let imageName = lowerCaseVehicleType;
    let hrefName = lowerCaseVehicleType;

    if (vehicleType.includes('/')) {
      // vehicles like 'SUV/Crossover' turn to suv for image and suv-crossover for href
      const splitVehicleType = lowerCaseVehicleType.split('/');
      imageName = splitVehicleType[0];
      hrefName = splitVehicleType.join('-');
    }

    const vehicleObject = {
      type: vehicleType,
      href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/${hrefName}`,
      imageUrl: `${atcBaseUrl}/psx-static/main//psx-buy-kbb/styles/new_default_desk_style_${imageName}.webp`,
      taggingLabel: `tile::srp::${hrefName}`,
      shortHand: hrefName,
      id: `${vehicleType}-id`,
    };

    vehicleObjects.push(vehicleObject);
  }
  return vehicleObjects;
};

export default function SellByTypesSection() {
  const [clickedItem, setClickedItem] = useState('');
  const [panelEvent, setPanelEvent] = useState();
  const vehicles = generateVehicleObjects();

  const onCarPanelClick = (event: any, carType: string) => {
    setClickedItem(carType);
    setPanelEvent(event);
  };

  useEffect(() => {
    if (clickedItem) {
      sendClick('atPSXStyleCategoryCTAClick', panelEvent, { carType: clickedItem });
      setClickedItem('');
      setPanelEvent(undefined);
    }
  }, [clickedItem, panelEvent]);

  return (
    <StyledDiv className="shop-by-style">
      <div className="shop-by-style-inner">
        <StyledHeading enableTitleCase={false} className="shop-by-style-heading" headingTag="h2" headingName="SectionHeading">
          See What&apos;s Selling In Your Area
        </StyledHeading>
        <Row className="style-container">
          <Col xs={12}>
            <Row>
              { vehicles.map((vehicle: any) => (
                <StyledCol
                  key={vehicle.id}
                  xs={6}
                  sm={6}
                  md={6}
                  xl={3}
                  className="item-column"
                >
                  <StyledImageLabel
                    labelText={vehicle.type}
                    href={vehicle.href}
                    size="default"
                    containerColor="white"
                    lazyImage
                    imageSrc={vehicle.imageUrl}
                    className="item-card"
                    onClick={(event: any) => onCarPanelClick(event, vehicle.shortHand)}
                    style={{
                      marginBottom: '1px',
                      fontWeight: 'bold',
                    }}
                  />
                </StyledCol>
              ))}
            </Row>
          </Col>
        </Row>
      </div>
    </StyledDiv>
  );
}
